"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = require("query-string");
var history_1 = require("./history");
function default_1() {
    var history = history_1.getHistory();
    if (history && history.location && history.location.search) {
        return queryString.parse(history.location.search);
    }
    return {};
}
exports.default = default_1;
